import React from 'react';

// 34 x 34
export const sortIcon = (
	<g>
		<rect width="34" height="34" rx="4" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 10.875C8 10.3918 8.33579 10 8.75 10H23.6613C24.0755 10 24.4113 10.3918 24.4113 10.875C24.4113 11.3582 24.0755 11.75 23.6613 11.75H8.75C8.33579 11.75 8 11.3582 8 10.875Z"
			fill="#0E233A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 17C8 16.5168 8.33579 16.125 8.75 16.125H15.2379C15.6521 16.125 15.9879 16.5168 15.9879 17C15.9879 17.4832 15.6521 17.875 15.2379 17.875H8.75C8.33579 17.875 8 17.4832 8 17Z"
			fill="#0E233A"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 23.125C8 22.6418 8.33579 22.25 8.75 22.25H13.5643C13.9785 22.25 14.3143 22.6418 14.3143 23.125C14.3143 23.6082 13.9785 24 13.5643 24H8.75C8.33579 24 8 23.6082 8 23.125Z"
			fill="#0E233A"
		/>
		<path
			d="M20.8119 15.5117V23.9175M20.8119 23.9175L24.0451 21.5974M20.8119 23.9175L17.4648 21.5974"
			stroke="#0E233A"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</g>
);
